export const ValutProgressLoader = () => (
  <div className="valut-progress-loader" aria-hidden="true">
    <span className="valut-progress-loader__ring valut-progress-loader__ring--outer" />
    <span className="valut-progress-loader__ring valut-progress-loader__ring--middle" />
    <span className="valut-progress-loader__ring valut-progress-loader__ring--inner" />
    <span className="valut-progress-loader__core" />
  </div>
);
